import { cn as e } from "../../cn.js";
import { RigoRadioGroup as t } from "./index.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
// src/design/forms/radio/presets.tsx
var i = ({ items: i, label: a, helperText: o, errorText: s, className: c, containerClassName: l, ...u }) => /* @__PURE__ */ r(t.Root, {
	className: e("gap-1", c),
	...u,
	children: [
		a && /* @__PURE__ */ n(t.Label, {
			className: "mb-0",
			children: a
		}),
		/* @__PURE__ */ n("div", {
			className: e("flex max-w-fit bg-muted rounded-md p-1 gap-1", l),
			children: i.map((i) => /* @__PURE__ */ r(t.Item, {
				className: "focus-ring-within rounded-md",
				value: i.value,
				disabled: i.disabled,
				children: [/* @__PURE__ */ n(t.Context, { children: (t) => /* @__PURE__ */ n("div", {
					className: e("px-3 py-1.5 bg-transparent rounded-md cursor-pointer transition-all duration-normal", t.value === i.value ? "bg-white shadow-sm" : "hover:bg-white/50", i.disabled && "opacity-50 cursor-not-allowed"),
					children: /* @__PURE__ */ n("div", {
						className: "text-sm font-medium text-foreground",
						children: i.label
					})
				}) }), /* @__PURE__ */ n(t.ItemHiddenInput, {})]
			}, i.value))
		}),
		o && !s && /* @__PURE__ */ n(t.HelperText, { children: o }),
		s && /* @__PURE__ */ n(t.ErrorText, { children: s })
	]
}), a = ({ items: i, label: a, helperText: o, errorText: s, orientation: c = "vertical", className: l, ...u }) => /* @__PURE__ */ r(t.Root, {
	className: e("gap-2", l),
	...u,
	children: [
		a && /* @__PURE__ */ n(t.Label, {
			required: u?.required,
			className: "mb-1",
			children: a
		}),
		/* @__PURE__ */ n("div", {
			className: e("flex gap-3", c === "vertical" ? "flex-col" : "flex-row flex-wrap"),
			children: i.map((i) => /* @__PURE__ */ r(t.Item, {
				className: "focus-ring-within rounded-md",
				value: i.value,
				disabled: i.disabled,
				children: [/* @__PURE__ */ n(t.Context, { children: (t) => /* @__PURE__ */ r("div", {
					className: e("flex items-start gap-3 p-3 rounded-md border-2 bg-white cursor-pointer transition-all duration-normal", t.value === i.value ? "border-primary" : "border-border hover:border-primary/50", i.disabled && "opacity-50 cursor-not-allowed"),
					children: [/* @__PURE__ */ n("div", {
						className: e("flex-shrink-0 w-4 h-4 rounded-full border border-border flex items-center justify-center", t.value === i.value ? "bg-primary" : " bg-white"),
						children: /* @__PURE__ */ n("div", { className: "w-2 h-2 rounded-full bg-white" })
					}), /* @__PURE__ */ r("div", {
						className: "flex-1 min-w-0",
						children: [/* @__PURE__ */ r("div", {
							className: "flex items-center gap-2",
							children: [i.icon && /* @__PURE__ */ n("div", {
								className: "flex-shrink-0 text-primary",
								children: i.icon
							}), /* @__PURE__ */ n("div", {
								className: "font-medium text-sm text-foreground",
								children: i.label
							})]
						}), i.description && /* @__PURE__ */ n("div", {
							className: "text-xs text-muted-foreground",
							children: i.description
						})]
					})]
				}) }), /* @__PURE__ */ n(t.ItemHiddenInput, {})]
			}, i.value))
		}),
		o && !s && /* @__PURE__ */ n(t.HelperText, { children: o }),
		s && /* @__PURE__ */ n(t.ErrorText, { children: s })
	]
}), o = ({ items: i, label: a, helperText: o, errorText: s, columns: c = 3, className: l, ...u }) => {
	let d = {
		2: "grid-cols-2",
		3: "grid-cols-2 md:grid-cols-3",
		4: "grid-cols-2 md:grid-cols-4"
	};
	return /* @__PURE__ */ r(t.Root, {
		className: e("gap-2", l),
		...u,
		children: [
			a && /* @__PURE__ */ n(t.Label, {
				className: "mb-1",
				children: a
			}),
			/* @__PURE__ */ n("div", {
				className: e("grid gap-3", d[c]),
				children: i.map((i) => /* @__PURE__ */ r(t.Item, {
					className: "focus-ring-within rounded-md",
					value: i.value,
					disabled: i.disabled,
					children: [/* @__PURE__ */ n(t.Context, { children: (t) => /* @__PURE__ */ r("div", {
						className: e("flex flex-col items-center justify-center gap-2 p-4 rounded-md border-2 cursor-pointer transition-all duration-normal min-h-[100px]", t.value === i.value ? "border-primary bg-secondary" : "border-border bg-card hover:border-primary/50", i.disabled && "opacity-50 cursor-not-allowed"),
						children: [
							i.icon && /* @__PURE__ */ n("div", {
								className: e("text-xl transition-colors", t.value === i.value ? "text-primary" : "text-muted-foreground"),
								children: i.icon
							}),
							/* @__PURE__ */ n("div", {
								className: "text-sm font-medium text-center text-foreground",
								children: i.label
							}),
							t.value === i.value && /* @__PURE__ */ n("div", {
								className: "w-5 h-5 rounded-full bg-primary flex items-center justify-center",
								children: /* @__PURE__ */ n("div", { className: "w-2.5 h-2.5 rounded-full bg-white" })
							})
						]
					}) }), /* @__PURE__ */ n(t.ItemHiddenInput, {})]
				}, i.value))
			}),
			o && !s && /* @__PURE__ */ n(t.HelperText, { children: o }),
			s && /* @__PURE__ */ n(t.ErrorText, { children: s })
		]
	});
}, s = ({ items: i, label: a, helperText: o, errorText: s, variant: c = "default", fullWidth: l = !1, className: u, ...d }) => /* @__PURE__ */ r(t.Root, {
	className: e("gap-2", u),
	...d,
	children: [
		a && /* @__PURE__ */ n(t.Label, {
			required: d?.required,
			children: a
		}),
		/* @__PURE__ */ n("div", {
			className: e("flex gap-2", l && "w-full", !l && "flex-wrap"),
			children: i.map((i) => /* @__PURE__ */ r(t.Item, {
				value: i.value,
				disabled: i.disabled,
				className: e("focus-ring-within rounded-md", l && "flex-1"),
				children: [/* @__PURE__ */ n(t.Context, { children: (t) => /* @__PURE__ */ n("div", {
					className: e("w-full px-2 py-1 rounded-md cursor-pointer transition-all duration-normal text-center", "border font-medium text-sm", c === "default" && (t.value === i.value ? "border-primary bg-primary text-white" : "border-border bg-card text-foreground hover:border-primary"), c === "primary" && (t.value === i.value ? "border-primary bg-primary text-white shadow-md" : "border-primary/30 bg-secondary text-primary hover:bg-secondary"), c === "outline" && (t.value === i.value ? "!border-primary bg-secondary text-primary" : "!border-border bg-transparent text-foreground hover:!border-primary hover:bg-secondary"), i.disabled && "opacity-50 cursor-not-allowed"),
					children: i.label
				}) }), /* @__PURE__ */ n(t.ItemHiddenInput, {})]
			}, i.value))
		}),
		o && !s && /* @__PURE__ */ n(t.HelperText, { children: o }),
		s && /* @__PURE__ */ n(t.ErrorText, { children: s })
	]
}), c = {
	SegmentedControl: i,
	CardRadio: a,
	TileRadio: o,
	ButtonGroupRadio: s
};
export { s as ButtonGroupRadio, a as CardRadio, c as RadioPresets, i as SegmentedControl, o as TileRadio };

//# sourceMappingURL=presets.js.map